(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["steady-home"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.steady-home').forEach(function(root){
  var chart = root.querySelector('.sh-chart');
  if(chart){
    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if(e.isIntersecting){ chart.classList.add('in-view'); io.disconnect(); } });
      }, {threshold:0.35});
      io.observe(chart);
    } else { chart.classList.add('in-view'); }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["steady-pdp"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.steady-pdp').forEach(function(root){
  // ---- 1:1 gallery slider ----
  var slider = root.querySelector('.sp-slider');
  if(slider){
    var slides = slider.querySelectorAll('.sp-slide');
    var dots = root.querySelectorAll('.sp-dot');
    var thumbs = root.querySelectorAll('.sp-thumb');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function current(){ return Math.round(slider.scrollLeft / slider.clientWidth); }
    function goTo(i){
      i = Math.max(0, Math.min(slides.length - 1, i));
      slider.scrollTo({ left: i * slider.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    }
    function setActive(i){
      dots.forEach(function(d, di){ d.classList.toggle('is-active', di === i); });
      thumbs.forEach(function(t, ti){ t.classList.toggle('is-active', ti === i); });
    }
    var prev = root.querySelector('.sp-snav--prev');
    var next = root.querySelector('.sp-snav--next');
    if(prev) prev.addEventListener('click', function(){ goTo(current() - 1); });
    if(next) next.addEventListener('click', function(){ goTo(current() + 1); });
    dots.forEach(function(d){ d.addEventListener('click', function(){ goTo(parseInt(d.getAttribute('data-index'), 10)); }); });
    thumbs.forEach(function(t){ t.addEventListener('click', function(){ goTo(parseInt(t.getAttribute('data-index'), 10)); }); });
    var st;
    slider.addEventListener('scroll', function(){
      clearTimeout(st);
      st = setTimeout(function(){ setActive(current()); }, 80);
    }, { passive: true });
    slider.addEventListener('keydown', function(e){
      if(e.key === 'ArrowLeft'){ e.preventDefault(); goTo(current() - 1); }
      if(e.key === 'ArrowRight'){ e.preventDefault(); goTo(current() + 1); }
    });
  }
  // ---- testimonial slider arrows ----
  var tslider = root.querySelector('.sp-tslider');
  if(tslider){
    var reduceT = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.querySelectorAll('.sp-tnav').forEach(function(btn){
      btn.addEventListener('click', function(){
        var card = tslider.querySelector('.sp-tslide');
        var step = card ? card.offsetWidth + 14 : tslider.clientWidth;
        tslider.scrollBy({ left: step * parseInt(btn.getAttribute('data-tdir'), 10), behavior: reduceT ? 'auto' : 'smooth' });
      });
    });
  }
  var atcs = root.querySelectorAll('.sp-atc');
  function setUrl(url){ if(!url) return; atcs.forEach(function(a){ a.setAttribute('href', url); }); }
  root.querySelectorAll('.sp-tier').forEach(function(tier){
    var input = tier.querySelector('input');
    tier.addEventListener('click', function(){
      if(input) input.checked = true;
      setUrl(tier.getAttribute('data-url'));
    });
    if(input && input.checked) setUrl(tier.getAttribute('data-url'));
  });
  var chart = root.querySelector('.sp-chart');
  if(chart){
    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if(e.isIntersecting){ chart.classList.add('in-view'); io.disconnect(); } });
      }, {threshold:0.35});
      io.observe(chart);
    } else { chart.classList.add('in-view'); }
  }
  // sticky CTA appears only after the hero/buy-box scrolls out of view
  var hero = root.querySelector('.sp-hero-sec');
  var sticky = root.querySelector('.sp-sticky');
  if(hero && sticky){
    if('IntersectionObserver' in window){
      var so = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting){ sticky.classList.remove('is-visible'); }
          else { sticky.classList.add('is-visible'); }
        });
      }, {threshold:0, rootMargin:'0px 0px -10% 0px'});
      so.observe(hero);
    } else { sticky.classList.add('is-visible'); }
  }
});

  } catch(e) { console.error(e); }
})();
})();
